import React from 'react';
import { Pagination } from 'react-admin';

const RequestPagination = props => (
    <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

export default RequestPagination;
